import React, {Component} from 'react'
import * as helpers from '../lib/helpers'
import './Input.css'

class Input extends Component {

  handleChange = (e) => {
    let target = e.target
    this.props.onChange(target.name, target.value)
  }

  render = () => (
        this.props.type !== 'select' ?  (
        <div className={`input-group ${this.props.className} ${this.props.value.length > 0 ? 'active' : ''}`}>
          <input type={this.props.type} 
                 name={this.props.name} 
                 ref={node => this.textInput = node} 
                 value={this.props.value} 
                 placeholder={this.props.placeholder} 
                 onChange={this.handleChange} 
                 onFocus={this.props.onFocus} 
                 onKeyDown={this.props.onKeyDown}/>
          <label onClick={() => this.textInput.focus()}>{this.props.label}</label>
        </div>
       ) : (
         <span className="input-group select-group input">
            <div className="select">
               <label for={this.props.name}>{this.props.label}</label>
               <select name={this.props.name} value={this.props.value} onChange={this.handleChange}>
                     {
                       this.props.options.map(opt => 
                         <option key={opt.id} value={opt.id}>
                           {helpers.removeSpecialChars(opt.display)}
                        </option>)
                      }
               </select>
            </div>
         </span>
       )
  )
}


export default Input



// WEBPACK FOOTER //
// ./src/components/Input.js